import { IBuyTicketsState, IEventFilter, defaultCalendarModel } from '../../classes/buytickets';
import { IEvent } from '../../classes/event';
import { ActionType, IBuyTicketsStateAction } from '../../classes/buytickets-actions';

import * as moment from 'moment';
import { IShowPosterInfo } from '../../classes/showPosterInfo';

/**
 * Returns the new search state given a particular action. This where all of the application
 * logic resides.
 */
export default function calendarReducer(state: IBuyTicketsState<IEvent> = defaultCalendarModel, action: IBuyTicketsStateAction) {
    switch (action.type) {
        case ActionType.RequestEvents: {
            return { ...state, updating: true } as IBuyTicketsState<IEvent>;
        }
        case ActionType.RequestBuyTicketsEvents: {
            return { ...state, updating: true } as IBuyTicketsState<IEvent>;
        }
        case ActionType.RequestBuyTicketsShowPosterInfo: {
            return { ...state, updating: true } as IBuyTicketsState<IEvent>;
        }
        case ActionType.UpdateEventFilter: {
            const updating = true;
            const addedFilterFunction = action.value;

            var eventFilter: IEventFilter[] = null;
            if (state.eventFilter.some(filter => { return filter.key === addedFilterFunction.key })) {
                eventFilter = state.eventFilter.filter(filter => !(filter.key === addedFilterFunction.key)).concat([addedFilterFunction]);
            } else {
                eventFilter = state.eventFilter.concat([addedFilterFunction])
            }
            const filterFunction = (event) => eventFilter.map(fil => { return fil.filter; }).every(f => f(event));
            return { ...state, eventFilter, filterFunction, updating } as IBuyTicketsState<IEvent>;
        }

        case ActionType.RemoveEventFilter: {
            const eventFilter = state.eventFilter.filter(filter => filter.key !== action.value);
            const filterFunction = (event: IEvent) => eventFilter.map(filter => filter.filter).every(func => func(event));

            return { ...state, eventFilter, filterFunction, updating: true } as IBuyTicketsState<IEvent>;
        }

        case ActionType.RemoveAllEventFilters: {
            return { ...state, eventFilter: [], filterFunction: (event: IEvent) => true, updating: true } as IBuyTicketsState<IEvent>;
        }

        case ActionType.EventApiError: {
            return { ...state, updating: false, apiError: action.value } as IBuyTicketsState<IEvent>;
        }

        case ActionType.ChangeProductionSeasonFilter: {
            const productionSeasonFilter = action.value as number;
            const updating = true;
            return { ...state, productionSeasonFilter, updating } as IBuyTicketsState<IEvent>;
        }
        case ActionType.UpdateEvents: {
            const events = action.value as Array<any>;

            return { ...state, updating: false, events: events } as IBuyTicketsState<IEvent>;
        }
        case ActionType.UpdateShowPosterInfo: {
            const updating = true;
            const showPosterInfo = action.value as IShowPosterInfo;
            return { ...state, updating, showPosterInfo: showPosterInfo } as any;
        }
        
        case ActionType.EventUpdated: {
            return { ...state, updating: false } as IBuyTicketsState<IEvent>;
        }
        case ActionType.BrowserNavigated: {
            state = action.value.state;
            state.updating = action.value.shouldUpdate;
            return state as IBuyTicketsState<IEvent>;
        }
        default:
            return state;
    }
}
